// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3Nfw0","label":"Category_label__ZIw9g","content":"Category_content__v0IjU","header":"Category_header__3W6TU","location":"Category_location__3-Vld"};